function getKey(clientId, idClienteEmpresa, mesAno) {
  return [
    "agentecontabilidade",
    clientId || "anon",
    "dre-simulacao-selecionada",
    idClienteEmpresa || "sem-empresa",
    mesAno || "sem-mes",
    "v1",
  ].join(":");
}

function getReferenceKey(clientId, idClienteEmpresa) {
  return [
    "agentecontabilidade",
    clientId || "anon",
    "dre-simulacao-referencia",
    idClienteEmpresa || "sem-empresa",
    "v1",
  ].join(":");
}

function getSimulationPrefix(clientId, idClienteEmpresa) {
  return [
    "agentecontabilidade",
    clientId || "anon",
    "dre-simulacao-selecionada",
    idClienteEmpresa || "sem-empresa",
  ].join(":");
}

export function readSelectedDreSimulation(clientId, idClienteEmpresa, mesAno) {
  if (!idClienteEmpresa || !mesAno) {
    return null;
  }

  try {
    return JSON.parse(sessionStorage.getItem(getKey(clientId, idClienteEmpresa, mesAno)) || "null");
  } catch (error) {
    return null;
  }
}

export function listSelectedDreSimulations(clientId, idClienteEmpresa) {
  if (!idClienteEmpresa) {
    return [];
  }

  const prefix = `${getSimulationPrefix(clientId, idClienteEmpresa)}:`;
  const suffix = ":v1";
  const simulations = [];

  try {
    for (let index = 0; index < sessionStorage.length; index += 1) {
      const key = sessionStorage.key(index);
      if (!key?.startsWith(prefix) || !key.endsWith(suffix)) {
        continue;
      }

      const mesAno = key.slice(prefix.length, -suffix.length);
      const simulation = JSON.parse(sessionStorage.getItem(key) || "null");
      if (simulation?.id && mesAno && mesAno !== "sem-mes") {
        simulations.push({ ...simulation, mesAnoBase: simulation.mesAnoBase || mesAno, mes_ano: mesAno });
      }
    }
  } catch (error) {
    return [];
  }

  return simulations;
}

export function readSelectedDreReference(clientId, idClienteEmpresa) {
  if (!idClienteEmpresa) {
    return null;
  }

  try {
    return JSON.parse(sessionStorage.getItem(getReferenceKey(clientId, idClienteEmpresa)) || "null");
  } catch (error) {
    return null;
  }
}

export function writeSelectedDreSimulation(clientId, idClienteEmpresa, mesAno, simulation) {
  if (!idClienteEmpresa || !mesAno || !simulation) {
    return;
  }
  sessionStorage.setItem(
    getKey(clientId, idClienteEmpresa, mesAno),
    JSON.stringify(simulation)
  );
}

export function writeSelectedDreReference(clientId, idClienteEmpresa, simulation) {
  if (!idClienteEmpresa || !simulation) {
    return;
  }

  sessionStorage.setItem(
    getReferenceKey(clientId, idClienteEmpresa),
    JSON.stringify(simulation)
  );
}

export function clearSelectedDreSimulation(clientId, idClienteEmpresa, mesAno) {
  if (!idClienteEmpresa || !mesAno) {
    return;
  }
  sessionStorage.removeItem(getKey(clientId, idClienteEmpresa, mesAno));
}

export function clearSelectedDreReference(clientId, idClienteEmpresa) {
  if (!idClienteEmpresa) {
    return;
  }

  sessionStorage.removeItem(getReferenceKey(clientId, idClienteEmpresa));
}

export function resolveDreSimulationForMonth(reference, monthlySimulation) {
  if (!reference?.id) {
    return null;
  }

  const sameVersion =
    monthlySimulation?.id &&
    String(monthlySimulation.id) === String(reference.id);
  const indicadores = sameVersion
    ? monthlySimulation.indicadores || reference.indicadores
    : reference.indicadores;

  return {
    ...reference,
    linhas: reference.linhas || {},
    colunas: sameVersion ? monthlySimulation.colunas || {} : {},
    ...(indicadores ? { indicadores } : {}),
  };
}

export function resolveInternalEmpresaId(empreendimentos = [], selectedValue) {
  const selected = String(selectedValue || "");
  const item = empreendimentos.find((candidate) =>
    [
      candidate?.idClienteEmpresa,
      candidate?.id_cliente_empresa,
      candidate?.codigoEmpresaErp,
      candidate?.codigo_empresa_erp,
    ].some((value) => String(value || "") === selected)
  );

  return String(item?.idClienteEmpresa || item?.id_cliente_empresa || "");
}
